import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { RootState } from '../store/slices';

export const useAppDispatch = () => useDispatch<ThunkDispatch<RootState, void, Action>>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
